import { render, staticRenderFns } from "./ToggleSuggestionsAbilityButton.vue?vue&type=template&id=53ad625b&"
import script from "./ToggleSuggestionsAbilityButton.vue?vue&type=script&lang=js&"
export * from "./ToggleSuggestionsAbilityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
